module.exports = __webpack_public_path__ + "static/img/mp3.a6890966.png";